<div class="cust-height">
  <div class="col-12 md:col-12">
    <p-table
      #dt
      [(selection)]="selectedDocs"
      selectionMode="multiple"
      [columns]="listColumns"
      [value]="lockDocs"
      [rows]="100"
      [paginator]="true"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      styleClass="rowexpand-table"
      dataKey="doc_docid"
      id="lockDocs"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right">{{'Lock_List' | translate}} {{'Tot' | translate}} {{ lockDocs.length }} {{'Doc_Bmm' | translate}}</span>
        </span>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          <th class="width-col-3">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="width-col-3">

          </th>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.sort"
                        [ngClass]="{
                            'width-col-13': col.type === 'DateTime',
                            'width-auto': col.type !== 'DateTime'
                        }"
              >
              @if (col.sort !== null) {
                <p-sortIcon [field]="col.sort"></p-sortIcon>
              }
              {{ col.header }}
              <input
                (click)="$event.stopPropagation()"
                pInputText
                type="text"
                (input)="dt.filter($event.target.value, col.field, 'contains')"
                style="color: darkgrey"
                />
              </th>
            }
            <th style="width: 3em">
              <button
                type="button"
                pButton
                icon="icons8-padlock-outline"
                class="margin cust-width"
                (click)="unLockDocs()"
              ></button>
            </th>
          </tr>
        </ng-template>
        <ng-template let-rowData let-columns="columns" pTemplate="body" let-expanded="expanded">
          <tr [pSelectableRow]="rowData">
            <td (click)="clickcolck($event)">
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            </td>
            <td>
              <button pButton type="button" [pRowToggler]="rowData" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            @for (col of columns; track col; let i = $index) {
              <td class="width-auto">
                @switch (col.field) {
                  @case ('doc_checkoutdate') {
                    <div class="align-left">
                      {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                  }
                  @default {
                      {{ rowData[col.field] }}
                  }
                }
              </td>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-lockDocs>
          <tr>
            <td colspan="7">
              <div class="p-3">
                <p-table [value]="lockDocs.bskList" dataKey="bsk_name">
                  <ng-template pTemplate="header">
                    <tr>
                      <th pSortableColumn="bsk_name">{{'Baskets' | translate}}  <p-sortIcon field="bsk_name"></p-sortIcon></th>
                      <th pSortableColumn="bsk_docdate">{{'&bsk_docdate' | translate}} <p-sortIcon field="bsk_docdate"></p-sortIcon></th>
                      <th pSortableColumn="bsk_docstatus">{{'&bsk_docstatus' | translate}} <p-sortIcon field="bsk_docstatus"></p-sortIcon></th>
                      <th style="width: 4rem"></th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-basket>
                    <tr>
                      <td>{{basket.bsk_label}} ({{basket.bsk_name}})</td>
                      <td>{{basket.bsk_docdate | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                      <td>{{basket.bsk_docstatus}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="6">{{'Bsk_Empty_2' | translate}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">{{'Empty' | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <app-item-confirm [key]="'alert'" [severity]="'alert'" (onAccept)="unLockDocs()"></app-item-confirm>
